import * as THREE from 'three'
import { ThreeExt } from './CoordUtils.js';
import './thirdparty/loaders/OBJLoader'
import './thirdparty/loaders/MTLLoader'
import './thirdparty/loaders/DDSLoader'
import {Car} from './car'
import {Plane} from './plane'


export class Navigator extends THREE.EventDispatcher {
  constructor(sceneManager, road, mode, showVehicle, airMode, flyHeight) {
    //airMode=undefined or 0 地面汽车模式
    //inside_car:0, behind_car:1, inside_plane:0, above_plane:1
    super();
    this.road = road;
    this.sceneManager = sceneManager;
    var camera = sceneManager.camera;
    this.assistCameraInCar = sceneManager.assistCameraInCar;
    this.path = new Array();
    //rawSpeed以公里/小时为单位，需要转换成每秒的速度
    this.rawSpeed = 100;
    this.speed = this.rawSpeed * 1000 / 3600;
    this.camera = camera;
    this.orgCameraPos = new THREE.Vector3();
    this.orgCameraTarget = new THREE.Vector3()
    this.orgCameraPos.copy(this.camera.get().position);
    this.orgCameraTarget.copy(this.camera.target);
    this.state = 0; //0-未运行 1-运行

    this.airMode = airMode;
    this.flyHeight = flyHeight;
  }

  getCameraPath() {
    var _this = this;
    var cameraInterval = 0;
    _this.path = [];
    this.road.roadModel.getAllStakes().map(item => {
      cameraInterval += item.stakeval;
      if (cameraInterval == 0 || cameraInterval >= 20){
        var itemPos = new THREE.Vector3(item.navPt.x, item.navPt.y, item.navPt.z)
        itemPos.stake = item;
        _this.path.push(itemPos);
        cameraInterval = 0;
      }
      
    });
  }

  initAirMode(){
    // console.log('airMode',this.airMode);
    // console.log('state',this,state)
    this.airMode = 1;
    this.flyHeight = 50;
  }

  initCarMode(){

   this.airMode = 2;
    this.flyHeight = 0; 
  }

  start(speed) {
    if(this.airMode==1){
      this.preparePlane(speed);
    }
    else if(this.airMode==2){
      this.prepareCar(speed);
    }

  }
  prepareCar(speed){
    var _this = this;
    if (this.vehicle == undefined) {   
      this.sceneManager.webView.taskManager.setTaskName('模拟驾驶准备中...');
      this.sceneManager.webView.taskManager.start();  
      var onProgress = function(xhr){
          if (xhr.lengthComputable) {
                  var percentComplete = xhr.loaded / xhr.total * 100;
                  _this.sceneManager.webView.taskManager.progress(percentComplete);
                }
      }

      this.vehicle = new Car();
      this.vehicle.load(function(){
              _this.sceneManager.webView.taskManager.end();
              // _this.vehicle.scale.set(0.01, 0.01, 0.01);
              //_this.vehicle.rotateY(Math.PI/4);
              _this.vehicle.addToScene( _this.sceneManager.scene);
              _this.startNav(speed);
              _this.hasCar=true;

      }, onProgress);
    }else if(this.vehicle.carModel == undefined){
      this.sceneManager.webView.taskManager.setTaskName('模拟驾驶准备中...');
      this.sceneManager.webView.taskManager.start();  
      var onProgress = function(xhr){
          if (xhr.lengthComputable) {
                  var percentComplete = xhr.loaded / xhr.total * 100;
                  _this.sceneManager.webView.taskManager.progress(percentComplete);
                }
      }

      this.vehicle = new Car();
      this.vehicle.load(function(){
              _this.sceneManager.webView.taskManager.end();
              // _this.vehicle.scale.set(0.01, 0.01, 0.01);
              //_this.vehicle.rotateY(Math.PI/4);
              _this.vehicle.addToScene( _this.sceneManager.scene);
              _this.startNav(speed);
              _this.hasCar=true;

      }, onProgress);
    }
    else{
      this.startNav(speed);
    }
  }

  preparePlane(speed){
    var _this = this;
    if (this.vehicle== undefined) {    
      this.sceneManager.webView.taskManager.setTaskName('模拟飞行准备中...');
      this.sceneManager.webView.taskManager.start();  
      var onProgress = function(xhr){
          if (xhr.lengthComputable) {
                  var percentComplete = xhr.loaded / xhr.total * 100;
                  _this.sceneManager.webView.taskManager.progress(percentComplete);
                }
      }

      this.vehicle = new Plane();
      this.vehicle.load(function(){
              _this.sceneManager.webView.taskManager.end();
              _this.vehicle.addToScene( _this.sceneManager.scene);
              _this.startNav(speed);
              _this.hasPlane=true;

      }, onProgress);
    }else if(this.vehicle.flyModel == undefined){
      this.sceneManager.webView.taskManager.setTaskName('模拟飞行准备中...');
      this.sceneManager.webView.taskManager.start();  
      var onProgress = function(xhr){
          if (xhr.lengthComputable) {
                  var percentComplete = xhr.loaded / xhr.total * 100;
                  _this.sceneManager.webView.taskManager.progress(percentComplete);
                }
      }

      this.vehicle = new Plane();
      this.vehicle.load(function(){
              _this.sceneManager.webView.taskManager.end();
              _this.vehicle.addToScene( _this.sceneManager.scene);
              _this.startNav(speed);
              _this.hasPlane=true;

      }, onProgress);
    }
    else{
      this.startNav(speed);
    }
  }

  startNav(speed) {
    //在有小车的情况下可以直接把车加载在scene中
    if(this.hasPlane&&this.airMode==1){
        this.sceneManager.scene.add(this.vehicle.flyModel);
    }else if(this.hasCar&&this.airMode==2){
        this.sceneManager.scene.add(this.vehicle.carModel);
    }
    this.rawSpeed = speed;
    this.speed = this.rawSpeed * 1000 / 3600;
    this.state = 1;
    this.getCameraPath();
    this.nextIndex = 1;
    this.nextCameraIndex = 2;
    this.curPos = new THREE.Vector3();
    this.curCameraPos = new THREE.Vector3();
    this.curPos.copy(this.path[0]); //回到原点
    
    this.curPos.stake = this.path[0].stake;
    this.curCameraPos.copy(this.path[1]);

    this.sceneManager.animationManager.addAnimationTarget("nav",  this);
  }
  stop(keepView) {
    // this.state = 0;
    // this.camera.move(this.orgCameraPos, this.orgCameraTarget);
    // this.sceneManager.switchCamera(this.camera);
    this.sceneManager.animationManager.removeAnimationTarget("nav");
    this.state = 0;
    if (keepView){
      return;
    }

    let orgCameraPos=new THREE.Vector3();
    orgCameraPos.copy(this.path[0]);
    orgCameraPos.y+=4;
    let orgCameraTarget=new THREE.Vector3();
    orgCameraTarget.copy(this.path[1]);
    orgCameraTarget.y+=2;
    this.camera.move(orgCameraPos,orgCameraTarget);
    this.sceneManager.switchCamera(this.camera);
    if(this.airMode==1){
        this.sceneManager.scene.remove(this.vehicle.flyModel);
    }else if(this.airMode==2){
        this.sceneManager.scene.remove(this.vehicle.carModel);
    }
    // this.sceneManager.webView.resetCarSpeed();
    this.sceneManager.webView.map.addMarker(this.path[0].stake);
    this.sceneManager.animationManager.removeAnimationTarget("nav");
    this.airMode=0;
    
  }

  incSpeed() {
    if (this.rawSpeed > 160) return;
    this.rawSpeed += 10;
    this.speed = this.rawSpeed * 1000 / 3600;
  }
  decSpeed() {
    if (this.rawSpeed <= 0) return;
    this.rawSpeed -= 10;
    this.speed = this.rawSpeed * 1000 / 3600;
  }

  getSpeed() {
    return this.rawSpeed;
  }

  incHeight() {
    this.flyHeight += 10;
  }
  decHeight() {
    if (this.flyHeight <= 10) return;
    this.flyHeight -= 10;
  }

  getHeight() {
    return this.flyHeight;
  }

  pause() {
    this.state = 2;
    this.sceneManager.animationManager.removeAnimationTarget("nav");
  }
  resume() {
    this.state = 1;
    this.sceneManager.animationManager.addAnimationTarget("nav",  this);
  }
  moveAFrame(delta) {
    //到终点了，停止
    let lastPath=this.path[this.path.length - 1];
    if (this.nextCameraIndex >= this.path.length - 10) {
      // 筑邦需求，跑完按钮回到播放样式
      this.sceneManager.webView.$refs.navControlPanel.player="play";
      this.sceneManager.webView.$refs.flyNavControlPanel.player="play";
      
      this.stop(true);
      return;
    }
    var distance = this.speed * delta;
    var cameraDistance = this.speed * delta;
    var nextPos = new THREE.Vector3();
    var nextCameraPos = new THREE.Vector3();
    nextPos.copy(this.path[this.nextIndex]);
    nextCameraPos.copy(this.path[this.nextCameraIndex]);

    var remainLength = new THREE.Vector3(nextPos.x, nextPos.y, nextPos.z).sub(this.curPos).length();
    var remainCameraLength = new THREE.Vector3(nextCameraPos.x, nextCameraPos.y, nextCameraPos.z).sub(this.curCameraPos).length();
    while (distance > remainLength) {
      //一个时间片的长度已经大于某个桩的剩余距离了就从这个桩终点开始往后面一个桩跑剩下的距离
      distance = distance - remainLength;
      this.curPos.copy(this.path[this.nextIndex]);

      this.curPos.stake = this.path[this.nextIndex].stake;
      if (this.nextIndex < this.path.length - 1) {
        this.nextIndex++;
        nextPos.copy(this.path[this.nextIndex]);
        remainLength = new THREE.Vector3(nextPos.x, nextPos.y, nextPos.z).sub(this.curPos).length();
      }
      // if (this.onStationChanged != undefined) {
      //   this.onStationChanged.call(this, this.road.getAllStations()[this.nextIndex - 1]);
      // }

    }
    //相机target的位置
    while (cameraDistance > remainCameraLength) {
      cameraDistance = cameraDistance - remainCameraLength;
      this.curCameraPos.copy(this.path[this.nextCameraIndex]);
      if (this.nextCameraIndex < this.path.length - 1) {
        this.nextCameraIndex++;
        nextCameraPos.copy(this.path[this.nextCameraIndex]);
        remainCameraLength = new THREE.Vector3(nextCameraPos.x, nextCameraPos.y, nextCameraPos.z).sub(this.curCameraPos).length();
      }

    }
    var alpha = distance / remainLength
    var cameraAlpha = cameraDistance / remainCameraLength;

    //计算线性插值的位置为当前位置
    this.curPos.lerp(this.path[this.nextIndex], alpha);
    this.curCameraPos.lerp(this.path[this.nextCameraIndex], cameraAlpha);
    var camDist = this.curPos.distanceTo(this.curCameraPos);
    this.vehicle.getPosition().lerpVectors(this.curPos, this.curCameraPos, 0.5);
    this.vehicle.getPosition().y += 0.1;
    this.vehicle.lookAt(this.curCameraPos);
    let cameraPos = new THREE.Vector3();
    cameraPos.copy(this.curPos);
    cameraPos.y += 4
    var lookAt = new THREE.Vector3();
    lookAt.copy(this.curCameraPos);
    lookAt.y += 2;
    
    if (this.airMode==1){
      cameraPos.y += this.flyHeight;
      this.camera.move(cameraPos, lookAt);
    }
    else{
      this.camera.move(cameraPos, lookAt);
      var carSeatPos = new THREE.Vector3(-0.4, 1, 0.3);
      var worldCarSeatPos = this.vehicle.carModel.localToWorld(carSeatPos);
      // console.log('wroldCarSeatPos',worldCarSeatPos);
      this.assistCameraInCar.move(worldCarSeatPos, lookAt);  
    }
    

    //更新地图
    if(this.sceneManager.webView.map){
      this.sceneManager.webView.map.addMarker(this.curPos.stake);  
    }
    
    
  }


}



// WEBPACK FOOTER //
// ./src/plugins/drawings3D/navigation.js